import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import PieChart from '../../charting/PieChart/PieChart.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import Inset from '../../Inset/Inset.jsx';
import PictureFrame from '../../PictureFrame/PictureFrame.jsx';
import CoveredVideoPlayer from '../../CoveredVideoPlayer/CoveredVideoPlayer.jsx';

const Section = (props) => {
    const componentRegistry = {};
    
    return <div className={"row yousections "+(props.right?"textonright":"textonleft")}> 
        <div className={"col l6"+(props.right?" push-l6":"")}>
            <h5>{props.title}</h5>
            {props.image&&!props.video?(<div className="yousectionimage">
                <PictureFrame caption={props.caption} credit={props.credit}> 
                    <img src={props.image} style={{width:"100%"}}/>
                </PictureFrame>
            </div>):null}
            {props.video&&props.image?(<div className="yousectionimage">
                <PictureFrame caption={props.caption} credit={props.credit}>
                    <CoveredVideoPlayer slug={props.video}>
                        <img src={props.image} style={{width:"100%"}}/>
                    </CoveredVideoPlayer>
                </PictureFrame>
            </div>):null}
            <Markdown>
                {contentToText(props.content,componentRegistry)}
            </Markdown>
        </div>
    </div> 
}



export default (props) => {
    return (<div className="container body-text">
        <div>
            {content['shipping-and-you-sections'].map((section,i) => <Section {...section} right={i%2===0}/>)}
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/YouSolutions/YouSolutions.jsx